import { Link } from "react-router-dom";
import faits from "../../assets/partner/faits.png";
import spiller from "../../assets/partner/spiller.svg";

function Sponsor() {
  return (
    <section id="sponsor" className="sponsor-section">
      <div>
        <div className="sponsor-header">
          <h2 className="base-title">I nostri partner</h2>
          <p className="base-subtitle"></p>
        </div>

        <div className="sponsor-grid">
          <Link to="https://faitsdarmes.com/" className="sponsor-image">
            <img src={faits} className="h-36" alt="Faits" />
          </Link>
          <Link to="https://spillerbirrerie.it/" className="sponsor-image">
            <img src={spiller} className="h-36" alt="Spiller" />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Sponsor;
